// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"vendors-node_modules_chakra-ui_avatar_dist_index_esm_js-node_modules_chakra-ui_button_dist_in-50adfd":"5dbe269a","src_Page_index_jsx-src_hooks_useAppTheme_js-src_providers_PreloaderProvider_index_jsx-src_ser-55b34e":"0b23bb15"}[chunkId] + ".chunk.css";
};